import React, { useState } from 'react';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
export const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real application, you would send the form data to a server
    // For this example, we'll just simulate a successful submission
    setFormStatus({
      submitted: true,
      error: false
    });
  };
  return <section id="contact" className="py-20 bg-gray-50" data-id="element-54">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-57">
            Get In Touch
          </h2>
          <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-58"></div>
          <p className="text-xl text-gray-600" data-id="element-59">
            Reach out to discuss potential investment opportunities
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-60">
          <div className="lg:w-1/2" data-id="element-61">
            <div className="bg-white rounded-lg shadow-md p-8" data-id="element-62">
              {formStatus.submitted ? <div className="text-center py-12" data-id="element-63">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-500 mb-6" data-id="element-64">
                    <Send size={24} data-id="element-65" />
                  </div>
                  <h3 className="text-2xl font-semibold mb-2 text-[#0a2351]" data-id="element-66">
                    Message Sent!
                  </h3>
                  <p className="text-gray-600" data-id="element-67">
                    Thank you for reaching out. Our team will get back to you
                    shortly.
                  </p>
                </div> : <form onSubmit={handleSubmit} data-id="element-68">
                  <div className="mb-6" data-id="element-69">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-70">
                      Full Name
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-71" />
                  </div>
                  <div className="mb-6" data-id="element-72">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-73">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-74" />
                  </div>
                  <div className="mb-6" data-id="element-75">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-76">
                      Company
                    </label>
                    <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-77" />
                  </div>
                  <div className="mb-6" data-id="element-78">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-79">
                      Message
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-80"></textarea>
                  </div>
                  <button type="submit" className="w-full py-3 px-4 bg-[#0a2351] text-white font-medium rounded-md hover:bg-[#0a2351]/90 transition-colors duration-300" data-id="element-81">
                    Submit
                  </button>
                </form>}
            </div>
          </div>
          <div className="lg:w-1/2" data-id="element-82">
            <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-83">
              <h3 className="text-xl font-semibold mb-6 text-[#0a2351]" data-id="element-84">
                Contact Information
              </h3>
              <div className="space-y-4" data-id="element-85">
                <div className="flex items-start" data-id="element-86">
                  <MapPin className="text-[#38b2ac] mr-4 mt-1" size={20} data-id="element-87" />
                  <div data-id="element-88">
                    <p className="font-medium" data-id="element-89">Main Office</p>
                    <p className="text-gray-600" data-id="element-90">
                      123 Finance Street, Suite 500
                      <br data-id="element-91" />
                      New York, NY 10001
                    </p>
                  </div>
                </div>
                <div className="flex items-center" data-id="element-92">
                  <Phone className="text-[#38b2ac] mr-4" size={20} data-id="element-93" />
                  <p className="text-gray-600" data-id="element-94">(212) 555-0123</p>
                </div>
                <div className="flex items-center" data-id="element-95">
                  <Mail className="text-[#38b2ac] mr-4" size={20} data-id="element-96" />
                  <p className="text-gray-600" data-id="element-97">info@sapiscapital.com</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md p-8" data-id="element-98">
              <h3 className="text-xl font-semibold mb-6 text-[#0a2351]" data-id="element-99">
                Subscribe to Our Newsletter
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-100">
                Stay updated with our latest investment insights and
                opportunities.
              </p>
              <form className="flex" data-id="element-101">
                <input type="email" placeholder="Your email address" className="flex-grow px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-102" />
                <button type="submit" className="px-4 py-2 bg-[#0a2351] text-white font-medium rounded-r-md hover:bg-[#0a2351]/90 transition-colors duration-300" data-id="element-103">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
};